'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFootballOutline = function IoIosFootballOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2z m3.2 30.7c0.2 0 0.3 0 0.6-0.1l1.9-5-1.6-3.1v0h-8.3l-1.6 3 2 5.1c0.2 0.1 0.4 0.1 0.5 0.1 1 0.3 2 0.4 3 0.4 1.1 0 2.4-0.1 3.5-0.4z m-16.3-21.7c-1.2 2.1-1.8 4.5-1.9 7l3.4-2.9z m7.9-6.8c-2.8 1.1-5.3 3-7 5.4l1.7 5 0.4 0.2 3.8 1.8 5.5-4.7v-4.6z m10.5 13.3l-5.4-4.5-5.4 4.5v0.1l1.4 5.6h8.1l1.4-5.6z m9.6 0.5c-0.1-2.5-0.7-5-1.9-7.1l-1.5 4.2z m-2.8-8.4c-1.7-2.4-4.2-4.4-7-5.4l-4.5 3.1v4.6l5.5 4.7 4.2-1.9z m-27 9.9c0.2 2.7 1.2 5.2 2.6 7.2l5.5 0.1 1.6-3.1-1.6-6 0 0-3.9-1.8z m21.6 7.3l5.5-0.1c1.4-2 2.4-4.5 2.6-7.2l-4.2-3.6-3.9 1.8-1.6 6z m-6.8-20.6l3.6-2.5c-1.1-0.3-2.3-0.4-3.5-0.4s-2.5 0.1-3.7 0.4z m-7 21.8l-4.2 0c1.6 1.8 3.6 3.2 5.9 4.1l-1.6-3.9z m12.4 4.1c2.3-0.9 4.3-2.3 5.9-4.1l-4.4 0-0.1 0.3z' })
        )
    );
};

exports.default = IoIosFootballOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-football-outline.js
// module id = 2648
// module chunks = 168707334958949